import React from "react";
import Class1Table from "./Class1Table.js";

export default function ResultDisplayClass1(props) {
    // will always be passed at least one parcel with a display class of 1
    // get all parcels with a display class of 1
    const resOne = props.res.filter(r => r.display_class === 1);
    return (
        <Class1Table res={resOne} address={props.address} />
    )
}